module.exports = __webpack_public_path__ + "static/media/macdonald.5224987a.PNG";